export default (cb = null) => {
  const ss360Config = {
    siteId: 'www.placetel.de',
    showErrors: false,
    language: 'de',
    suggestions: {
      showImages: false,
      minChars: 3,
      num: 10,
      throttleTime: 300,
      forceBelow: true
    },
    style: {
      accentColor: '#1c9ee2',
      themeColor: '#1c9ee2'
    },
    searchBox: {
      placeholder: 'Suchen Sie z.B. nach \"Voicemail\" ...',
      selector: '.ss360SearchBox',
      searchButton: '.btn-search'
    },
    results: {
      embedConfig: {
        contentBlock: '.modal-searchresults'
      },
      moreResultsButton: 'Weitere Ergebnisse anzeigen',
      caption: '#COUNT# Treffer auf Ihre Suche nach \'#QUERY#\'.',
      group: true,
      num: 15,
      highlightQueryTerms: true,
      noResultsText: 'Entschuldigung, wir haben keine Treffer auf Ihre Suchanfrage gefunden.',
      queryCorrectionText: 'Meinten Sie \'#CORRECTION#\'?'
    },
    contentGroups: {
      include: [
        'Webseite',
        'Funktionen',
        'Online-Hilfe',
        'Shop',
        'Ratgeber'
      ],
      otherName: 'Webseite'
    },
    layout: {
      navigation: {
        position: 'top',
        type: 'tabs',
        tabTitle: '#COUNT# Treffer in #NAME# auf Ihre Suche nach \'#QUERY#\'.'
      },
      mobile: {
        showUrl: false,
        showImages: false
      },
      desktop: {
        showUrl: false,
        showImages: false
      }
    },
    callbacks: {
      preSuggest: function (query, searchbox) {
        if (searchbox.getAttribute('data-search') === 'hilfe') {
          SS360.changeConfig('contentGroups.include', ['Online-Hilfe']);
          SS360.changeConfig('contentGroups.exclude', ['Webseite', 'Funktionen', 'Online-Hilfe Telefonanlage', 'Shop', 'Ratgeber']);
        } else if (searchbox.getAttribute('data-search') === 'funktionen') {
          SS360.changeConfig('contentGroups.include', ['Funktionen']);
          SS360.changeConfig('contentGroups.exclude', ['Webseite', 'Online-Hilfe', 'Online-Hilfe Telefonanlage', 'Shop', 'Ratgeber']);
        } else if (searchbox.getAttribute('data-search') === 'shop') {
          SS360.changeConfig('contentGroups.include', ['Shop']);
          SS360.changeConfig('contentGroups.exclude', ['Webseite', 'Funktionen', 'Online-Hilfe', 'Online-Hilfe Telefonanlage', 'Ratgeber']);
        } else if (searchbox.getAttribute('data-search') === 'hilfe-uc') {
          SS360.changeConfig('contentGroups.include', ['Online-Hilfe UC']);
          SS360.changeConfig('contentGroups.exclude', ['Webseite', 'Funktionen', 'Online-Hilfe', 'Online-Hilfe Telefonanlage', 'Shop', 'Ratgeber']);
        } else if (searchbox.getAttribute('data-search') === 'hilfe-telefonanlage') {
          SS360.changeConfig('contentGroups.include', ['Online-Hilfe Telefonanlage']);
          SS360.changeConfig('contentGroups.exclude', ['Webseite', 'Funktionen', 'Online-Hilfe', 'Shop', 'Ratgeber']);
        } else if (searchbox.getAttribute('data-search') === 'ratgeber') {
          SS360.changeConfig('contentGroups.include', ['Ratgeber']);
          SS360.changeConfig('contentGroups.exclude', ['Webseite', 'Funktionen', 'Online-Hilfe', 'Online-Hilfe Telefonanlage', 'Shop']);
        } else {
          SS360.changeConfig('contentGroups.include', ['Webseite', 'Funktionen', 'Online-Hilfe', 'Shop', 'Ratgeber']);
          SS360.changeConfig('contentGroups.exclude', ['Online-Hilfe Telefonanlage']);
        }
        return query.length >= 2;
      },
      preSearch: function (query, sort, selectedSearchBox) {
        if (selectedSearchBox) {
          var currentSearchBox = selectedSearchBox.parent().find('input').get()[0];
          SS360.changeConfig('results.caption', currentSearchBox.getAttribute('data-searchresultscaption'));
          SS360.changeConfig('results.noResultsText', currentSearchBox.getAttribute('data-noresultstext'));
          SS360.changeConfig('emptyQuerySuggestions', currentSearchBox.getAttribute('data-nosuggests'));

          if (currentSearchBox.getAttribute('data-search') === 'hilfe') {
            SS360.changeConfig('contentGroups.include', ['Online-Hilfe']);
            SS360.changeConfig('contentGroups.exclude', ['Webseite', 'Funktionen', 'Online-Hilfe Telefonanlage', 'Shop', 'Ratgeber']);
          } else if (currentSearchBox.getAttribute('data-search') === 'hilfe-telefonanlage') {
            SS360.changeConfig('contentGroups.include', ['Online-Hilfe Telefonanlage']);
            SS360.changeConfig('contentGroups.exclude', ['Webseite', 'Funktionen', 'Online-Hilfe', 'Shop', 'Ratgeber']);
          } else if (currentSearchBox.getAttribute('data-search') === 'funktionen') {
            SS360.changeConfig('contentGroups.include', ['Funktionen']);
            SS360.changeConfig('contentGroups.exclude', ['Webseite', 'Online-Hilfe', 'Online-Hilfe Telefonanlage', 'Shop', 'Ratgeber']);
          } else if (currentSearchBox.getAttribute('data-search') === 'shop') {
            SS360.changeConfig('contentGroups.include', ['Shop']);
            SS360.changeConfig('contentGroups.exclude', ['Webseite', 'Funktionen', 'Online-Hilfe', 'Online-Hilfe Telefonanlage', 'Ratgeber']);
          } else if (currentSearchBox.getAttribute('data-search') === 'ratgeber') {
            SS360.changeConfig('contentGroups.include', ['Ratgeber']);
            SS360.changeConfig('contentGroups.exclude', ['Webseite', 'Funktionen', 'Online-Hilfe', 'Online-Hilfe Telefonanlage', 'Shop']);
          } else {
            SS360.changeConfig('contentGroups.include', ['Webseite', 'Funktionen', 'Online-Hilfe', 'Shop', 'Ratgeber']);
            SS360.changeConfig('contentGroups.exclude', ['Online-Hilfe Telefonanlage']);
          }

          if (currentSearchBox.getAttribute('data-target') !== 'modal-searchresults') {
            SS360.changeConfig('results.embedConfig', { 'contentBlock': '.' + currentSearchBox.getAttribute('data-target') });
          } else {
            SS360.changeConfig('results.embedConfig', { 'contentBlock': '.modal-searchresults' });

            if (currentSearchBox.getAttribute('id')) {
              var $target = $(document.getElementById('modal-search'));
              if ($target.length > 0) {
                if (!$target.hasClass('in')) {
                  $target.modal('toggle');
                }
              } else {
                modal('search');
              }
              switchSearch(currentSearchBox.getAttribute('data-search'));
            }
          }
        }

        return true;
      }
    }
  };

  const src = 'https://cdn.sitesearch360.com/v13/sitesearch360-v13.min.js';

  window.switchSearch = (search) => {
    document.querySelectorAll('.modal-search input').forEach(el => el.dataset.search = 'search');
  };

  let afterInit = () => {
    if (document.querySelector('.btn-search')) {
      // Site Search 360
      const onSearchClick = (searchButton) => {
        let searchBox = searchButton.closest('form').querySelector('input');
        searchBox.disabled = false;
        searchButton.addEventListener('click', (event) => {
          event.preventDefault();
          let e = jQuery.Event('keyup');
          e.which = 13;
          e.keyCode = 13;
          $(searchBox).trigger(e);
          event.stopPropagation();
          return false;
        });
        if (cb) {
          cb();
        }
      };
      document.querySelectorAll('.btn-search').forEach(onSearchClick);
    }
  };

  if (document.querySelector(`script[src="${src}"]`)) {
    if (window.ss360Config) {
      // nothing to do, already initialized
      afterInit();
      return;
    }
    // only include script once, i.e. remove the old one and add the new one
    document.querySelector(`script[src="${src}"]`).remove();
  }

  window.ss360Config = ss360Config;

  let script = document.createElement('script');
  script.src = src;
  script.type = 'text/javascript';
  script.async = 'true';
  script.onload = script.onreadystatechange = function () {
    afterInit();
  };
  document.head.appendChild(script);
};
